import React from 'react';
import { useTranslation } from 'react-i18next';
import { MultiValue } from 'chakra-react-select';

import { HOURS } from 'app/common/views/profile-editor/form-helper';
import { TermsOfService } from 'app/common/components/onboarding/terms-of-service';
import MentorOpportunity from 'app/common/components/onboarding/mentor-opportunity';
import { FormFields } from 'app/common/views/profile-editor/form-types';
import { Option, specializedApprovedLanguages } from 'app/helpers/form-helper';
import { SpecializedMentorRoles } from 'app/common/components/onboarding/specialized-mentor-roles';
import { SpecializedMentorLocale } from 'app/common/components/onboarding/specialized-mentor-locale';

import CONFIG from 'configLoader';
import styles from '../profile-editor.module.scss';
import { LanguageChangeEvent } from '../profile-editor';

type AbbreviatedSpecializedMentorFormProps = {
  fields: FormFields;
  handleFieldChange: ({ id, value }: { id: string; value: string | number }) => void;
  handleMultiCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>, id: string) => void;
  handleMultiSelectChange: (e: LanguageChangeEvent) => void;
};

export const AbbreviatedSpecializedMentorForm: React.FC<AbbreviatedSpecializedMentorFormProps> = ({
  fields,
  handleFieldChange,
  handleMultiCheckboxChange,
  handleMultiSelectChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <MentorOpportunity
        label={t('mentorProfile.form.imAbleToDedicate', {
          numOfHours: HOURS.specialized,
        })}
        id="available_hours"
        value={HOURS.specialized}
        isChecked={fields.available_hours === HOURS.specialized}
        handleChange={(e) => {
          handleFieldChange({
            id: 'available_hours',
            value: HOURS.specialized,
          });
        }}
      />

      <SpecializedMentorRoles
        label={t('mentorProfile.imInterested')}
        handleMultiCheckboxChange={handleMultiCheckboxChange}
        roles={fields.roles ?? []}
      />

      <SpecializedMentorLocale
        languageOptions={specializedApprovedLanguages}
        languages={fields.languages ?? []}
        onChangeLanguages={(e) => handleMultiCheckboxChange(e, 'languages')}
        onChangeMultiSelectLanguages={(e: LanguageChangeEvent) => handleMultiSelectChange(e)}
      />
      <div className={styles.tos}>
        <TermsOfService
          id="gov_mentor_agreement_version"
          link={CONFIG.mentorAgreementUrl}
          handleTOS={(e) => {
            handleFieldChange({
              id: 'gov_mentor_agreement_version',
              value: CONFIG.latestAgreementVersionGov,
            });
          }}
          isChecked={!!fields.gov_mentor_agreement_version}
        />
      </div>
    </>
  );
};
